// EGY TERV-TÉTEL: még nem számlázott, de a hónapban esedékes szolgáltatás. A jelölők kimondják, MIÉRT ennyi:
// „becslés" (használat-alapú — az előző számla alapján) · „használat szerint" (nincs becslés) · „arányosított".
// A kártya alakja a közös `PortalCard` (ugyanaz, mint a számláé és a szolgáltatásé).
import type { PortalPlanItem } from '@atlas/contracts';
import { useTranslation } from 'react-i18next';

import { PortalCard, PortalCardTitle } from '@/components/portal/portal-card';
import { PortalSharedBadge } from '@/components/portal/portal-shared-badge';
import { DomainBadge } from '@/components/shared/domain-badge';
import { MoneyBlock } from '@/components/shared/money-block';
import { Text } from '@/components/ui/text';
import { formatDayRange, frequencyKey } from '@/features/portal/billing-format';

export function PortalPlanItemRow({ item }: { item: PortalPlanItem }): JSX.Element {
  const { t, i18n } = useTranslation();
  const freq = frequencyKey(item.frequency);
  const period = formatDayRange(item.periodStart, item.periodEnd, i18n.language);
  const hasAmount = item.amount !== null && item.currency !== null;
  return (
    <PortalCard
      as="li"
      data-testid="portal-plan-item"
      title={<PortalCardTitle>{item.serviceName}</PortalCardTitle>}
      amount={
        hasAmount ? (
          <MoneyBlock net={item.amount ?? undefined} currency={item.currency ?? ''} />
        ) : undefined
      }
      badges={
        <>
          {freq !== null && (
            <DomainBadge
              kind="frequency"
              value={freq}
              label={t(`portal.billing.frequency.${freq}`)}
            />
          )}
          {!hasAmount && (
            <DomainBadge
              kind="portalBilling"
              value="usage"
              label={t('portal.billing.plan.usageAmount')}
            />
          )}
          {item.estimated && (
            <DomainBadge
              kind="portalBilling"
              value="estimate"
              label={t('portal.billing.plan.estimate')}
              title={t('portal.billing.plan.estimateHint')}
            />
          )}
          {item.prorated && (
            <DomainBadge
              kind="portalBilling"
              value="prorated"
              label={t('portal.billing.plan.prorated')}
            />
          )}
          <PortalSharedBadge shared={item.shared} />
        </>
      }
      meta={
        <>
          {period !== null && (
            <Text variant="secondary" as="p">
              {t('portal.billing.invoice.period')}: {period}
            </Text>
          )}
          {item.estimated && (
            <Text variant="secondary" as="p">
              {t('portal.billing.plan.estimateHint')}
            </Text>
          )}
        </>
      }
    />
  );
}
